/**
 * Custom Search Enhancement for Prestige Theme
 * Preserves native prefix searching in predictive search.
 */
(() => {
  if (window.__customSearchInitialized) {
    return;
  }
  window.__customSearchInitialized = true;
})();
